/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { BaseModel } from "@Internal/Models";
import { ICustomDate } from "@Internal/Contracts";

/* Console role. Privileges are flat booleans (one per resource right); the UI groups them by
   resource and enforces the cascade (Create/Update imply Read). Shared between Console backend and
   frontend. */
export default class BaseRole extends BaseModel {
    Name?: string;
    Description?: string;
    IsProtected?: boolean;
    CreatedBy?: string;
    UpdatedBy?: string;
    CreatedAt?: ICustomDate;
    UpdatedAt?: ICustomDate;

    /* Plan. */
    PlanRead?: boolean;
    PlanUpdate?: boolean;

    /* Coupon (Bon de réduction). */
    CouponCreate?: boolean;
    CouponRead?: boolean;

    /* Customer (Client). */
    CustomerCreate?: boolean;
    CustomerRead?: boolean;

    /* Ads publication (Portail d'annonces). */
    AdsPublicationCreate?: boolean;
    AdsPublicationRead?: boolean;

    constructor( id: number, name?: string ) {
        super( id );

        this.Name = name;
    }
}
